import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BottomNavigation from '../components/BottomNavigation';
import './PaymentStatus.css';

const PaymentStatus: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  // Mock data - would come from API
  const payment = {
    id: 1,
    courseTitle: 'Advanced Mathematics',
    amount: 53.9,
    tax: 4.9,
    status: 'pending', // pending, approved, rejected
    submittedDate: '2024-02-06',
    reviewedDate: null,
    rejectionReason: null
  };

  const getStatusInfo = () => {
    switch (payment.status) {
      case 'approved':
        return {
          icon: '✅',
          title: 'Payment Approved',
          message: 'Your payment has been approved. You now have full access to the course.',
          color: '#4caf50'
        };
      case 'rejected':
        return {
          icon: '❌',
          title: 'Payment Rejected',
          message: payment.rejectionReason || 'Your payment proof was rejected. Please check the reason and resubmit.',
          color: '#f44336'
        };
      default:
        return {
          icon: '⏳',
          title: 'Under Review',
          message: 'Your payment proof is being reviewed by our team. You will be notified once the review is complete.',
          color: '#ff9800'
        };
    }
  };

  const statusInfo = getStatusInfo();

  return (
    <div className="payment-status-page">
      <header className="payment-status-header">
        <button className="back-button" onClick={() => navigate('/orders')}>
          ←
        </button>
        <h1>Payment Status</h1>
        <div className="header-spacer"></div>
      </header>

      <div className="payment-status-content">
        {/* Status Card */}
        <div className="status-card" style={{ borderTopColor: statusInfo.color }}>
          <div className="status-icon-large">{statusInfo.icon}</div>
          <h2 className="status-title">{statusInfo.title}</h2>
          <p className="status-message">{statusInfo.message}</p>
        </div>

        {/* Payment Details */}
        <div className="payment-details-card">
          <h3 className="card-title">Payment Details</h3>
          <div className="detail-row">
            <span className="detail-label">Course:</span>
            <span className="detail-value">{payment.courseTitle}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Amount:</span>
            <span className="detail-value">${payment.amount}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Tax:</span>
            <span className="detail-value">${payment.tax}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Submitted:</span>
            <span className="detail-value">{payment.submittedDate}</span>
          </div>
          {payment.reviewedDate && (
            <div className="detail-row">
              <span className="detail-label">Reviewed:</span>
              <span className="detail-value">{payment.reviewedDate}</span>
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="status-actions">
          {payment.status === 'rejected' && (
            <button
              className="action-button resubmit-button"
              onClick={() => navigate(`/payment/${id}/proof`)}
            >
              Resubmit Payment Proof
            </button>
          )}
          {payment.status === 'approved' && (
            <button
              className="action-button access-button"
              onClick={() => navigate(`/course/${id}`)}
            >
              Access Course
            </button>
          )}
          <button
            className="action-button back-to-orders-button"
            onClick={() => navigate('/orders')}
          >
            Back to Orders
          </button>
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
};

export default PaymentStatus;
